const TRIBE_LEADERBOARDS = {
  Investors: 'system_groups_investors',
  RealInvestors: 'system_groups_real_investors',
  Fitness: 'system_groups_fitness'
}

export default TRIBE_LEADERBOARDS
